import {
  FETCH_ROLES,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILURE,
  CREATE_ROLES,
  CREATE_ROLES_SUCCESS,
  CREATE_ROLES_FAILURE,
} from "./actionTypes";

// Fetch Roles
export const fetchRoles = (unitId) => ({
  type: FETCH_ROLES,
  payload: { unitId }
});

export const fetchRolesSuccess = (roles) => ({
  type: FETCH_ROLES_SUCCESS,
  payload: roles,
});

export const fetchRolesFailure = (error) => ({
  type: FETCH_ROLES_FAILURE,
  payload: error,
});

export const createRoles = (formData) => ({ type: CREATE_ROLES, payload: {formData} });
export const createRolesSuccess = (roles) => ({ type: CREATE_ROLES_SUCCESS, payload: roles });
export const createRolesFailure = (error) => ({ type: CREATE_ROLES_FAILURE, payload: error });

